import { render } from "./VoiceCDRDetails.vue?vue&type=template&id=551627f7"
import script from "./VoiceCDRDetails.vue?vue&type=script&lang=js"
export * from "./VoiceCDRDetails.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__